enum BannerTypes {
  Image = 'image',
  Video = 'video',
};

export default BannerTypes;